<template>
    <div class="sidebar">
        <div class="cell" @click="goto('/shoppingcart')">
            <!-- <i class="el-icon-shopping-cart-full"></i> -->
                 <img src="../../assets/img/icon/cart_gray.svg" style="width:20px;height:20px" >

            <p>购物车</p>
        </div>
        <!-- <div class="cell">
            <i class="el-icon-star-on"></i>
            <p>我的收藏</p>
        </div> -->
        <div class="cell" @click="goto('/mine/myquestion')">
            <!-- <i class="el-icon-chat-line-round"></i> -->
                 <img src="../../assets/img/icon/msg.svg" style="width:20px;height:20px" >

            <p>客户服务</p>
        </div>
        <el-backtop class="cell">
            <!-- <i class="el-icon-arrow-up"></i> -->
                 <img src="../../assets/img/icon/up.svg" style="width:20px;height:20px" >

            <p>返回顶部</p>
        </el-backtop>
    </div>
</template>

<script>
    import { useRouter } from 'vue-router'
    export default {
        name: 'SideBar',
        setup() {
            let router = useRouter()
            let goto = (url) => {
                router.push(url)
            } 
            return {
                goto
            }
        }
    }
</script>

<style scoped lang="scss">
    .sidebar {
        position: fixed;
        top: 40%;
        right: 20px;
        z-index: 999;
        ::v-deep(.el-backtop) {
            position: static;
            box-shadow: none;
            border-radius: 0;
            display: block;
            color: #999;
        }
        .cell {
            text-align: center;
            width: 65px;
            height: 78px;
            padding-top: 15px;
            border: 1px solid rgba(238, 238, 238, 1);
            margin-bottom: 2px;
            cursor: pointer;
            i {
                font-size: 22px;
                color: #999;
            }
            p {
                font-size: 12px;
                margin-top: 5px;
                color: #999;
            }
            &:hover {
                background: rgba(245, 47, 62, 1);
                i {
                    color: #fff;
                }
                p {
                    color: #fff;
                }
            }
        }
    }
</style>